import { parseISO } from 'date-fns';
import { usePendingOrder } from './usePendingOrder';

export const useNextDeliveryTarget = subscription => {
  const { order, isLoading } = usePendingOrder(subscription?.id);
  let nextDeliveryDate = null;

  // If pendingOrder exists, pull the nextDeliveryDate from it. If it doesn't, pull it
  // from subscription
  if (!isLoading && order) {
    nextDeliveryDate = parseISO(order.delivery_date);
  } else if (subscription) {
    nextDeliveryDate = parseISO(subscription.next_delivery_target);
  }

  return {
    isNextDeliveryTargetLoading: !nextDeliveryDate,
    nextDeliveryDate,
  };
};
